import { BaseModel, RecursivePartial } from "../base";

export class VzParamStyles extends BaseModel {
    enumNames?: string[];
    subtype?: string;
    hidden?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    singleLine?: boolean;
    borderless?: boolean;
    autosize?: { minRows?: number, maxRows?: number };

    // prefix?: string;
    // suffix?: string;
    // size?: any;
    // checkedSymbol?: string;
    // uncheckedSymbol?: string;
    // maxWidth?: number | string;
    // minWidth?: number | string;
    // textAlign?: string;
    // nzType?: string;
    // loading?: boolean;
    // vzType?: string;
    // icon?: string;
    placeholder?: string;
    // margin?: number | string;
    // nomobile?: boolean;
    // layout?: 'horizontal' | 'vertical';
    // flex?: boolean;
    showCopyButton?: boolean;
    // generateUniqueIds?: boolean;

    constructor(json?: RecursivePartial<VzParamStyles>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<VzParamStyles>): VzParamStyles {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<VzParamStyles>): void {
        VzParamStyles.assignFields<VzParamStyles>(this, json, [
            'enumNames',
            'subtype',
            'hidden',
            'disabled',
            'readonly',
            'singleLine',
            'borderless',
            'autosize',

            // 'prefix',
            // 'suffix',
            // 'size',
            // 'checkedSymbol',
            // 'uncheckedSymbol',
            // 'maxWidth',
            // 'minWidth',
            // 'textAlign',
            // 'nzType',
            // 'loading',
            // 'vzType',
            // 'icon',
            'placeholder',
            // 'margin',
            // 'nomobile',
            // 'layout',
            // 'flex',
            'showCopyButton',
            // 'generateUniqueIds',
        ]);
        if (this.enumNames && !Array.isArray(this.enumNames)) {
            this.enumNames = undefined;
        }
    }
}
